import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsViewsByEmailCampaignQuery } from "../graphql/queries";
import type {
  AnalyticsViewsByEmailCampaignQueryType,
  AnalyticsViewsByEmailCampaignQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsViewsByEmailCampaignQuery = (
  options?: QueryHookOptions<
    AnalyticsViewsByEmailCampaignQueryType,
    AnalyticsViewsByEmailCampaignQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsViewsByEmailCampaignQueryType,
    AnalyticsViewsByEmailCampaignQueryVariablesType
  >(AnalyticsViewsByEmailCampaignQuery, options);
};
